import React, { Component } from "react";
import ProjectsListItem from "./ProjectsListItem";
import PropTypes from "prop-types";

import { Link } from "react-router-dom";

import noProjects from "../../../img/no-projects.svg";
import notFound from "../../../img/magnigier.svg";

export default class ProjectsList extends Component {
  static contextTypes = {
    currentLanguage: PropTypes.object,
    translate: PropTypes.func,
  };

  render() {
    const { list, isOk } = this.props;

    if (!isOk) {
      // Пока данные не пришли — не показываем ничего (или Preloader)
      return null;
    }
    if (
      !list ||
      (Array.isArray(list.active) &&
        list.active.length === 0 &&
        Array.isArray(list.archive) &&
        list.archive.length === 0)
    ) {
      return <NotFound translate={this.context.translate} />;
    }
    return (
      <div className="page__projects">
        <div className="projects-list">
          <div className="projects-list__items">
            {list.map((item) => (
              <ProjectsListItem
                key={"project-" + item.ProjectId}
                item={item}
                lesseeCount={this.props.lesseeCount}
                downloadContractSchedule={this.props.downloadContractSchedule}
                activeTab={this.props.activeTab}
                getDocuments={this.props.getDocuments}
                resetTrigger={this.props.resetTrigger}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export function EmptyList({ translate }) {
  return (
    <div className="page__no-projects">
      <div className="info-widget info-widget_centred-projects">
        <div className="info-widget__head">
          <img className="info-widget__image" src={noProjects} alt="" />
        </div>
        <div className="info-widget__title">
          {translate("У вас пока нет одобренных проектов")}
        </div>
        <div className="info-widget__message">
          {translate("")}
          <br />
        </div>
        <div className="info-widget__footer">
          <Link
            className="info-widget__footer-btn u-btn u-btn_orange"
            to="/applications/create"
          >
            {translate("Создать заявку")}
          </Link>
        </div>
      </div>
    </div>
  );
}

function NotFound({ translate }) {
  return (
    <div className="info-widget">
      <div className="info-widget__head">
        <img className="info-widget__image" src={notFound} alt="" />
      </div>
      <div className="info-widget__title">{translate("Ничего не найдено")}</div>
      <div className="info-widget__message">
        {translate("Пожалуйста, повторите запрос с другими параметрами.")}
      </div>
    </div>
  );
}
